import { singlePubSubConst } from './constants';

type FnVoid = () => void;
type EventKeys = keyof typeof singlePubSubConst;
type EventTypes = (typeof singlePubSubConst)[EventKeys];

class PubSubSingle {
  private subscribers: Record<EventTypes, FnVoid | null> = {
    [singlePubSubConst.RESET_DATE_PICKER]: null,
  };

  subscribe(event: EventTypes, cb: FnVoid) {
    const exists = this.subscribers[event];

    if (exists) {
      return;
    }

    this.subscribers[event] = cb;
  }

  notify(event: EventTypes) {
    this.subscribers[event]?.();
  }

  unsubscribe(event: EventTypes) {
    this.subscribers[event] = null;
  }
}

const singlePubSub = new PubSubSingle();

export { singlePubSub, singlePubSubConst };
